import { useEffect, useState } from 'react';
import {
  getSsoOrganizationMap,
  OrganizationId,
  SsoOrganizationMap,
  tryToGetSSOOrganizationIdFromEmailValue,
} from '../../../ory/utils/ssoOrganizations';

interface IUseSsoOrganizations {
  ssoOrganizationId?: string;
}
interface IUseSsoOrganizationsProps {
  email: string;
  setIsSSOLogin: React.Dispatch<React.SetStateAction<boolean>>;
}

export function useLoginSsoOrganizations({ email, setIsSSOLogin }: IUseSsoOrganizationsProps): IUseSsoOrganizations {
  const [ssoOrganizationId, setSSOOrganizationId] = useState<OrganizationId | undefined>(undefined);

  useEffect(() => {
    tryToGetSSOOrganizationId({
      email,
      setIsSSOLogin,
      setSSOOrganizationId,
      ssoOrganizationMap: getSsoOrganizationMap(),
    });
  }, [email]);

  return {
    ssoOrganizationId,
  };
}

export async function tryToGetSSOOrganizationId({
  email,
  setIsSSOLogin,
  setSSOOrganizationId,
  ssoOrganizationMap,
}: {
  email: string;
  ssoOrganizationMap: SsoOrganizationMap | undefined;
  setSSOOrganizationId: React.Dispatch<React.SetStateAction<string | undefined>>;
  setIsSSOLogin: React.Dispatch<React.SetStateAction<boolean>>;
}): Promise<void> {
  const organizationId = await tryToGetSSOOrganizationIdFromEmailValue(email, ssoOrganizationMap);
  setSSOOrganizationId(organizationId);
  setIsSSOLogin(!!organizationId);
}
